"use client"; // Error boundaries must be Client Components

import { Typography, Button, Container } from "@repo/ui";
import { useEffect } from "react";
import { Home, RotateCw } from "lucide-react";
import Image from "next/image";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
  }, [error]);

  return (
    <div className="min-h-[inherit] flex items-center justify-center bg-gradient-to-b from-blue-50/50 to-blue-100/50">
      <Container className="container mx-auto px-4 py-16 text-center">
        <div className="max-w-2xl mx-auto">
          {/* Error Illustration */}
          <div className="relative mb-8">
            <Image
              src="/images/503ErrorServiceUnavailable.svg"
              alt="Error illustration"
              width={300}
              height={200}
              className="mx-auto w-auto h-auto"
              priority
            />
          </div>

          {/* Error Message */}
          <Typography
            variant="h2"
            className="text-3xl font-bold text-gray-800 mb-4 mt-8"
          >
            Oops! Something went wrong
          </Typography>
          <Typography className="text-gray-600 mb-8">
            {`An unexpected error has occurred. Please try again, or return to the homepage.`}
          </Typography>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              color="primary"
              variant="contained"
              className="inline-flex items-center gap-2"
              onClick={() => reset()}
              startIcon={<RotateCw className="w-5 h-5" />}
            >
              Try Again
            </Button>
            <Button
              color="primary"
              variant="outlined"
              className="inline-flex items-center gap-2"
              href="/"
              startIcon={<Home className="w-5 h-5" />}
            >
              Back to Home
            </Button>
          </div>
        </div>
      </Container>
    </div>
  );
}
